// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8764) return "static/chunks/8764-e9036b8560582d7f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f","8869":"031aa83e"}[chunkId] || chunkId) + "." + {"1167":"9fb5bdb1c4e15f51","2937":"87d1ebbfcc031111","4394":"ea6e8f792f28d4ea","5279":"6299a13d1068aa7d","7229":"022d8f6b9f287c5c","8869":"d3aad6ab22247e13"}[chunkId] + ".js";
};